import { createFileRoute } from '@tanstack/react-router';
import SystemComparison from '../../components/InternalPortal/Comparison';
import { PERMISSION_INTERNAL_PORTAL } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/system-comparison')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_INTERNAL_PORTAL, ['read'], '/unauthorized', context);

    return {
      ...context,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: SystemComparisonRoute,
});

function SystemComparisonRoute() {
  return <SystemComparison />;
}
